/*
 * Bundle colours — cross-product colour selector.
 *
 * Colour swatches for products listed in custom.bundle_colours are rendered as
 * links (.bundle-swatch) inside the native Colour swatch group. Each carries a
 * data-size-variants map ("size-handle:variant-id,…") for its target product.
 *
 * On click we read the size currently selected on the reference product, look up
 * the matching variant id on the target, and navigate to <target>?variant=<id>.
 * Shopify's selected_or_first_available_variant + the theme's own init then select
 * that size on load — no client-side race, no load-time patching required.
 */
(function () {
  'use strict';

  function findSizeGroup(scope) {
    return (scope || document).querySelector('[data-option-role="size"]');
  }

  function selectedSizeIn(scope) {
    var group = findSizeGroup(scope);
    if (!group) return null;
    var checked = group.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  // Match Liquid's | handle for size labels (lowercase, non-alphanumerics -> single dash).
  function handleize(value) {
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function variantForSize(link, size) {
    var map = link.getAttribute('data-size-variants');
    if (!map || !size) return null;
    var wanted = handleize(size);
    var found = null;
    map.split(',').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i > -1 && pair.slice(0, i) === wanted) {
        found = pair.slice(i + 1);
      }
    });
    return found;
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest ? e.target.closest('.bundle-swatch') : null;
      if (!link) return;

      var url = link.getAttribute('href');
      if (!url) return;

      var form = link.closest('.product_form') || document;
      var size = selectedSizeIn(form);
      var variantId = variantForSize(link, size);

      e.preventDefault();
      e.stopImmediatePropagation();

      if (variantId) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
      }
      window.location.href = url;
    },
    true
  );
})();
